module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-global-image-85684c1691fe543c0068b83c549bf328.png";